import { render, staticRenderFns } from "./ResourceDetailsModal.vue?vue&type=template&id=eae681e4&scoped=true"
import script from "./ResourceDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceDetailsModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResourceDetailsModal.vue?vue&type=style&index=0&id=eae681e4&prod&scoped=true&lang=css"
import style1 from "./ResourceDetailsModal.vue?vue&type=style&index=1&id=eae681e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae681e4",
  null
  
)

export default component.exports